import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { format, fromUnixTime } from 'date-fns';
import { TooltipProps } from 'recharts';
import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent';
import { PHASES_COLORS } from '../../../../../../../const';
import './index.scss';

type LiveTooltipProps = {
  tooltipProps: TooltipProps<ValueType, NameType>;
  unit: string;
  fixed: number;
  selectedPhases: number[];
};

export const LiveTooltip: React.FC<LiveTooltipProps> = ({ tooltipProps, unit, fixed, selectedPhases }) => {
  const { t } = useTranslation('channel-details');

  const isSummary = useMemo(() => selectedPhases.length === 1 && selectedPhases[0] === 0, [selectedPhases]);

  if (!tooltipProps?.active || !tooltipProps?.label || !tooltipProps.payload?.length) {
    return null;
  }

  const phasesValues: number[] = tooltipProps.payload?.[0].payload?.phasesValues || [];
  const filteredValues = isSummary
    ? phasesValues.map((value, index) => ({ phase: index + 1, value }))
    : selectedPhases.map((phase) => ({ phase, value: phasesValues[phase - 1] }));

  return (
    <div className="live-tooltip">
      <p className="live-tooltip__label">{format(fromUnixTime(tooltipProps.label), 'HH:mm:ss')}</p>
      {filteredValues.length ? (
        filteredValues.map(({ phase, value }) => (
          <p key={phase} className="live-tooltip__value">
            <span className="live-tooltip__value-heading" style={{ color: PHASES_COLORS[phase] }}>
              {`${t('phase')} ${phase}: `}
            </span>
            {`${value.toFixed(fixed)} ${unit}`}
          </p>
        ))
      ) : (
        <p className="live-tooltip__value live-tooltip__value--color-accent">
          {tooltipProps.payload?.[0].value} {unit}
        </p>
      )}
    </div>
  );
};
